import { GroupActions, GroupPurpose } from "../Constants/Constants";

/**
 * @param {*} data : response from get group api
 * @returns Array of objects as required by group table
 */
export const convertGroupList = (data) => {
  const list = data?.groups || [];
  return list.map((item) => {
    return {
      key: item.groupid,
      groupId: item.groupid,
      providerId: item.providerid,
      entitlementId: item.entitlementid,
      groupName: item.groupname,
      providerName: item.providername,
      entitlementName: item.entitlementname,
      purpose: item.purpose,
      description: item.description,
      logisticStatus: item.logisticstatus,
      groupDetails: item.groupdetails,
      protected: item.protected,
      status: item.groupstatus,
      services: item.services,
      serviceTierName: item.servicetiername,
    };
  });
};

/**
 * @param {*} formData : group form submitted values
 * @param {*} action : action type: add or edit
 * @returns Object formatted as required by create or update api
 */
export const convertGroupFormToApiValues = (
  formData,
  action = GroupActions.add
) => {
  console.log("convertGroupFormToApiValues", formData);
  const returnData = {
    entitlementid: formData.entitlementId,
    description: formData.description,
    logisticstatus: formData.logisticStatus,
    purpose: GroupPurpose.entitlement.value,
  };
  if (action === GroupActions.add) {
    returnData.groupname = formData.groupName;
    returnData.providerid = formData.providerId;
  }
  if (action === GroupActions.edit) {
    returnData.groupid = formData.groupId;
  }
  return returnData;
};

/**
 * @param {*} formData : group update form submitted values
 * @param {*} action : action type: add device or add provider
 * @returns Object formatted as required by add to group api
 */
export const convertGroupUpdateFormToApiValues = (formData) => {
  const returnData = { ids: [], associationtag: formData?.purpose };
  formData.itemsToAdd?.forEach((item) => {
    returnData.ids.push({ id: item });
  });
  console.log("returnData", returnData);
  return returnData;
};

/**
 * @param {*} data : response from get group api
 * @returns Array of objects as required by group dropdown
 */
export const convertGroupListToDropdown = (data) => {
  const list = data?.groups || [];
  return list.map((item) => {
    return {
      groupId: item.groupid,
      groupName: item.groupname,
      purpose: item.purpose,
    };
  });
};
